module.exports = __webpack_public_path__ + "img/trygg-e-handel-liggande.svg";